import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { API } from "../lib/api";
import { FunnelRenderer } from "../components/FunnelRenderer";

export default function PublicFunnel() {
  const { slug } = useParams();
  const [sp] = useSearchParams();
  const [f, setF] = useState(undefined);
  useEffect(() => { fetch(`${API}/public/funnels/${slug}`).then((r) => (r.ok ? r.json() : null)).then(setF); }, [slug]);
  if (f === undefined) return null;
  if (!f) return <div className="min-h-screen grid place-items-center text-muted-foreground" data-testid="funnel-not-found">Page not found</div>;
  const step = f.steps?.[Number(sp.get("step") || 0)] || f.steps?.[0];
  return <div className="min-h-screen bg-white" data-testid="public-funnel"><FunnelRenderer step={step} /></div>;
}
